import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const theme = {
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        // primary: '#d033333',
        success: '#66ff66',
        info: '#2196f3',
        error: '#b22222',
      }
    }
  }
}

export default new Vuetify(theme)